var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6948 8.59371L14.8017 12.3887L15.721 17.7487C15.7407 17.8636 15.7279 17.9818 15.6839 18.0898C15.64 18.1978 15.5667 18.2914 15.4723 18.3599C15.378 18.4285 15.2663 18.4692 15.15 18.4776C15.0337 18.486 14.9174 18.4617 14.8142 18.4075L10.0004 15.8768L5.18729 18.4068C5.08407 18.4611 4.96773 18.4854 4.85142 18.477C4.73511 18.4686 4.62347 18.4278 4.52912 18.3593C4.43477 18.2908 4.36148 18.1972 4.31753 18.0892C4.27357 17.9812 4.26072 17.863 4.28041 17.7481L5.19979 12.3881L1.30604 8.59371C1.22246 8.51228 1.16335 8.40909 1.13539 8.2958C1.10743 8.18251 1.11175 8.06366 1.14785 7.9527C1.18395 7.84174 1.25039 7.7431 1.33965 7.66795C1.42891 7.59279 1.53742 7.54413 1.65291 7.52746L7.03354 6.74621L9.43979 1.86996C9.65041 1.44309 10.3504 1.44309 10.561 1.86996L12.9673 6.74621L18.3479 7.52746C18.4631 7.54457 18.5713 7.59347 18.6603 7.66868C18.7492 7.74388 18.8155 7.84241 18.8515 7.95318C18.8875 8.06396 18.892 8.18259 18.8643 8.29574C18.8366 8.4089 18.7779 8.51208 18.6948 8.59371Z",
    fill: "#FF8C42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.1e9e1b4ce30aae18f483c521002f1f81.svg";
export { ForwardRef as ReactComponent };